import { Trans, withI18n } from 'lingui-react';
import { compact } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { Text } from 'base-components';

import WithI18n from 'components/WithI18n';

import { evaluateOperatingStatusType } from 'utils/operatingStatusFilter';

function DealerOperatingStatusLabel({ dealer, now }) {
  return (
    <WithI18n
      render={({ i18n }) => {
        const { modifier, value } = evaluateOperatingStatusType(
          dealer,
          now,
          i18n,
        );
        return (
          <Text modifiers={compact(['fontWeightMedium', modifier])}>
            <Trans id={value} />
          </Text>
        );
      }}
    />
  );
}

DealerOperatingStatusLabel.propTypes = {
  dealer: PropTypes.shape({}).isRequired,
  now: PropTypes.shape({}).isRequired,
};

export default withI18n()(DealerOperatingStatusLabel);



// WEBPACK FOOTER //
// ./src/components/DealerOperatingStatusLabel/index.js